import React from 'react';
import NotFoundContent from 'components/NotFoundContent/NotFoundContent';

export default function NotFound() {
  return <NotFoundContent />;
}
